import {DB} from "./index";

const insert_sql = "insert or replace into t_translate(mid,src,desc) values(?, ?, ?)"

export async function insert_translate(db: DB, data: Translate) {
    const params = [data.mid, data.src, data.desc];
    return await db.Execute(insert_sql, params);
}


export async function qry_translate(db: DB, mid: string): Promise<{ data?: Translate, error?: any }> {
    const sql = `SELECT * FROM t_translate WHERE mid = ?`
    const r = await db.Query(sql, [mid]);
    if (r.data && r.data.length > 0) {
        return {data: r.data[0]}
    }
    return {error: r.error}
}

export async function cancel_translate(db: DB, mid: string): Promise<{ error?: any }> {
    const sql = `DELETE FROM t_translate WHERE mid = ?`
    const r = await db.Execute(sql, [mid]);
    return {error: r.error}
}

export type Translate = {
    mid: string,
    desc: string,
    src: string,
}